// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { inspect } from "node:util";

export const custom = inspect.custom;
